module.exports = require("mitt");


//////////////////
// WEBPACK FOOTER
// external "mitt"
// module id = 13
// module chunks = 0 1